import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private
        exact
        key="FedRegistries"
        path="/fed-registries"
        component={Page} />
];

export default Routes;